import gsap from "gsap/all";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default (items = []) => ({
  total: 0,
  pagination: {
    page: 1,
    perPage: 24,
    listWindow: 5,
    maxPage: 1,
  },

  init() {
    this.$watch("pagination.page", () => {
      // only scroll on desktop sizes
      if (window.innerWidth < 768) return;

      gsap.to(window, {
        delay: 0.1,
        duration: 0.5,
        scrollTo: { y: ".transactions-table", offsetY: 120 },
      });
    });
  },

  get filteredItems() {
    this.pagination.maxPage = Math.ceil(items.length / this.pagination.perPage);
    this.total = items.length;

    return items.slice(
      (this.pagination.page - 1) * this.pagination.perPage,
      this.pagination.page * this.pagination.perPage
    );
  },

  get pages() {
    const fullList = Array.from(Array(this.pagination.maxPage).keys()).map(
      (x) => ++x
    );
    const windowIndex = Math.ceil(
      this.pagination.page / this.pagination.listWindow
    );
    return fullList.slice(
      (windowIndex - 1) * this.pagination.listWindow,
      windowIndex * this.pagination.listWindow
    );
  },

  get paginationHasPreviousListWindow() {
    return this.pagination.page > this.pagination.listWindow;
  },

  get paginationHasNextListWindow() {
    return (
      Math.ceil(this.pagination.page / this.pagination.listWindow) <
      Math.ceil(this.pagination.maxPage / this.pagination.listWindow)
    );
  },

  viewPage(page = 1) {
    this.pagination.page = Math.min(Math.max(page, 1), this.pagination.maxPage);
  },

  paginationGoToPage(page) {
    return {
      ["@click"]() {
        this.viewPage(page);
      },
      [":class"]() {
        return this.pagination.page === parseInt(page) ? "active" : null;
      },
    };
  },

  paginationGoToFirstPage: {
    ["@click"]() {
      this.viewPage();
    },
    [":disabled"]() {
      return this.pagination.page <= 1;
    },
  },

  paginationGoToPreviousPage: {
    ["@click"]() {
      this.viewPage(this.pagination.page - 1);
    },
    [":disabled"]() {
      return this.pagination.page <= 1;
    },
  },

  paginationGoToNextPage: {
    ["@click"]() {
      this.viewPage(this.pagination.page + 1);
    },
    [":disabled"]() {
      return this.pagination.page >= this.pagination.maxPage;
    },
  },

  paginationGoToLastPage: {
    ["@click"]() {
      this.viewPage(this.pagination.maxPage);
    },
    [":disabled"]() {
      return this.pagination.page >= this.pagination.maxPage;
    },
  },
});
